import {mapState,mapMutations} from 'vuex'
import {filters} from "../filters";
import permissionToggler from '../../components/permissionToggler'
import {usersInAccount} from "../utils/usersInAccount";

export const addThing = {
  mixins: [filters, usersInAccount],
  components: {
    permissionToggler
  },
  data() {
    return {
      users: [],
      roles: [],
      level: 1,
    }
  },
  computed: {
    ...mapState({
      rolesData: state => state.roles.ownedRoles
    }),
    rolesArr() {
      return this.rolesData.map(item => {
        return {
          name: `${item.name}`,
          id: item.id,
        }
      })
    },
    //уровни доступа временно закоментирую
    showPermissions() {
      return (this.users.length > 0 || this.roles.length > 0)
    }
  }
}
